<description-wizard [(prompt)]="prompt"/>
<div class="dx-fieldset" *ngIf="prompt">
  <div class="dx-field">
    <dx-toolbar>
      <dxi-item
        location="after"
        widget="dxButton"
        [options]="{ stylingMode: 'outlined', text: 'Generieren' | translate, width: '100%', onClick: confirmGenerate }"
      />
    </dx-toolbar>
  </div>
  <div class="dx-field" *ngIf="promptResult || loading">
    <div class="dx-field-label" style="display: flex; align-items: center; gap: 6px;">
      <span>{{ 'Ergebnis' | translate }}</span>
      <i #resultInfoTarget class="bi bi-info-circle" style="cursor: help;"></i>
      <dx-tooltip [target]="resultInfoTarget"
                  class="toolTip toolTipField"
                  position="bottom"
                  targetAnchor="bottom"
                  showEvent="mouseenter"
                  hideEvent="mouseleave">
        <div *dxTemplate="let data of 'content'">
          <div style="max-width: 450px; white-space: pre-line; text-align: left;">{{ 'PromptResultTooltip' | translate }}</div>
        </div>
      </dx-tooltip>
    </div>
      <div class="dx-field-value prompt-result-value" id="promptResult">
          <div *ngFor="let entry of promptResultEntries; trackBy: trackByField" class="prompt-result-item">
              <div class="prompt-result-label" *ngIf="entry.field">{{ entry.label }}</div>
              <div class="prompt-result-row">
                  <div class="prompt-result-textarea-wrap">
                      <dx-text-area [value]="entry.value" [readOnly]="true" [autoResizeEnabled]="true"/>
                  </div>
                  <div class="prompt-result-confidence" *ngIf="entry.confidence != null" [class]="confidenceColorClass(entry.confidence)">{{ entry.confidence }}%</div>
              </div>
          </div>
      <dx-load-panel
        #loadPanel
        shadingColor="rgba(0,0,0,0.4)"
        [position]="{ of: '#promptResult' }"
        [(visible)]="loading"
        [showIndicator]="true"
        [showPane]="true"
        [shading]="true"
        [hideOnOutsideClick]="false"
      ></dx-load-panel>
    </div>
  </div>
</div>


<div class="dx-fieldset" *ngIf="!loading">
  <div class="dx-field">
    <dx-toolbar>
      <dxi-item
        location="after"
        widget="dxButton"
        [options]="{ stylingMode: 'outlined', text: 'Anwenden' | translate, width: '100%', onClick: applyResult }"
      />
    </dx-toolbar>
  </div>
</div>


